import React, { useState } from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import { Row, Col, Card } from 'react-bootstrap'
import { useMunicipalityIssue } from 'api/hooks/use-municipality-issues'
import { useParams } from 'react-router-dom'
import { SeverityBadge } from 'shared/badges'
import IssueLog from './IssueLogs'
import IssueSubscriptionToggle from './IssueSubscriptionToggle'

function Issue() {
  const { id } = useParams()
  const { data: issue, isSuccess } = useMunicipalityIssue({ id })
  const defaultParams = {
    id: id,
    log_status: 'unresolved',
    page: 1,
    perPage: 10,
    orderDirection: 'desc',
    search: ''
  }
  const crumbs = [
    { name: 'Access Management', url: 'duties' },
    { name: 'Issues', url: 'issues' },
    { name: issue?.issue?.name, url: '' }
  ]
  const [params, setParams] = useState(defaultParams)

  return (
    <Page
      title={'Issue: ' + (isSuccess ? issue?.issue?.name : '')}
      className="mb-4"
    >
      <PageTitle breadcrumbs={crumbs} />
      {isSuccess && (
        <>
          <Card className="shadow-sm">
            <Card.Body>
              <Row>
                <Col md={2}>
                  <div>
                    <div className="text-muted">Severity</div>
                    <div className="text-dark">
                      <SeverityBadge
                        severity={issue.severity}
                        count={issue.count}
                        displayCount={true}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <InfoBlock
                    label="Unresolved"
                    value={`${issue.unresolved_count} Unresolved`}
                  />
                </Col>
                <Col md={2}>
                  <InfoBlock
                    label="Resolved"
                    value={`${issue.resolved_count} Resolved`}
                  />
                </Col>
                <Col md={2}>
                  <InfoBlock
                    label="Ignored"
                    value={`${issue.ignored_count} Ignored`}
                  />
                </Col>
                <Col md={2}>
                  {false && (
                    <InfoBlock
                      label="Enabled"
                      value={
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            checked={issue?.is_issue_enabled}
                            readOnly
                          />
                        </div>
                      }
                    />
                  )}
                </Col>
              </Row>
              <Row className="mt-3 border-top border-light pt-3">
                <Col md={2}>
                  <div className="text-muted">Description</div>
                </Col>
                <Col md={10}>
                  <div className="text-dark">{issue?.issue?.description}</div>
                </Col>
              </Row>
              <Row className="mt-3 border-top border-light pt-3">
                <Col md={2}>
                  <div className="text-muted">Resolution</div>
                </Col>
                <Col md={10}>
                  <div className="text-dark">{issue?.issue?.resolution}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </>
      )}

      <Row className="mt-3">
        <Col md={3}>
          {isSuccess && (
            <IssueSubscriptionToggle municipalityIssueId={issue.id} />
          )}
        </Col>
        <Col md={9}>
          {isSuccess && (
            <IssueLog
              issueId={issue?.id}
              params={params}
              setParams={setParams}
            />
          )}
        </Col>
      </Row>
    </Page>
  )
}

// Info Block Component
const InfoBlock = ({ label, value }) => (
  <div>
    <div className="text-muted">{label}</div>
    <div className="text-dark">{value}</div>
  </div>
)

export default Issue
